import React from "react";

const SmartStockPrivacyPolicy = () => {
  return (
    <div className="container mx-auto px-4 py-40">
      <h1 className="text-3xl font-bold mb-6">
        Privacy Policy for Smart Stock
      </h1>

      <p className="mb-4">
        <strong>Effective Date:</strong> 15-01-2025
      </p>

      <p className="mb-6">
        Smart Stock values your privacy and is committed to protecting your
        personal information. This Privacy Policy explains how we collect, use,
        and disclose your information when you use our Shopify app.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        1. Information We Collect
      </h2>

      <h3 className="text-xl font-medium mb-2">
        a. Personal Information
      </h3>
      <p className="mb-2">
        When you install and use our app, we may collect the following
        information:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          Shopify store information, including store name, domain, and email
          address.
        </li>
      </ul>

      <h3 className="text-xl font-medium mb-2">b. App Usage Data</h3>
      <p className="mb-2">
        We may collect data related to your interactions with the app, including:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          SKU, barcode, inventory levels, and location data you manage through
          the app.
        </li>
        <li>
          Logs of import/export actions, such as file names and timestamps.
        </li>
      </ul>

      <h3 className="text-xl font-medium mb-2">
        c. Device and Technical Information
      </h3>
      <p className="mb-2">
        We may collect technical details, such as:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Browser type and version.</li>
        <li>IP address.</li>
        <li>Shopify API interactions.</li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        2. How We Use Your Information
      </h2>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>Provide and improve the store’s functionality.</li>
        <li>
          Allow seamless inventory management and bulk editing.
        </li>
        <li>
          Offer technical support and respond to your inquiries.
        </li>
        <li>
          Analyze usage trends to enhance the app experience.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        3. Information Sharing
      </h2>
      <p className="mb-2">
        We do not sell, rent, or trade your personal information. However, we
        may share information with third parties in the following scenarios:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Shopify APIs:</strong> To enable app functionality.
        </li>
        <li>
          <strong>Service Providers:</strong> For hosting, data processing, or
          analytics.
        </li>
        <li>
          <strong>Legal Compliance:</strong> When required to comply with legal
          obligations or enforce our rights.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mb-4">
        4. Data Retention
      </h2>
      <p className="mb-6">
        We retain your data only for as long as necessary to fulfill the
        purposes outlined in this Privacy Policy. If you uninstall the app, we
        will delete your personal information unless required by law to retain
        it.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        5. Data Security
      </h2>
      <p className="mb-6">
        We implement robust security measures to protect your data. However, no
        method of transmission over the internet or electronic storage is 100%
        secure, and we cannot guarantee absolute security.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        6. Changes to This Policy
      </h2>
      <p className="mb-6">
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page, and the "Effective Date" will be revised
        accordingly.
      </p>

      <h2 className="text-2xl font-semibold mb-4">
        7. Contact Us
      </h2>
      <p className="mb-2">
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <ul className="list-disc list-inside mb-4 ml-4">
        <li>
          <strong>Email:</strong>{" "}
          <a
            href="mailto:support@mean3.com"
            className="text-blue-500 hover:underline"
          >
            support@mean3.com
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SmartStockPrivacyPolicy;